































































































































import { defineComponent, computed } from '@nuxtjs/composition-api';
import { useI18n, useTrustPilotWidget } from '~/composables';
import {
  TRUSTPILOT_MINI_WIDGET_WIDTH,
  TRUSTPILOT_MINI_WIDGET_HEIGHT,
} from '~/constants/ui';
import { trustpilotMiniWidgetId } from '~/config';
import YearsOfExperience from '~/components/atoms/YearsOfExperience/YearsOfExperience.vue';
import HeurekaWidget from '~/components/atoms/Heureka/HeurekaWidget.vue';
import { HEUREKA_WIDGET_DATA } from '~/config/shared';

export default defineComponent({
  name: 'TrustedBy',
  components: {
    YearsOfExperience,
    HeurekaWidget,
  },
  setup() {
    const { languageAndCountry, countryCode } = useI18n();
    const { showTrustPilotWidget } = useTrustPilotWidget();
    const heurekaWidgetOptions = computed(() => HEUREKA_WIDGET_DATA[countryCode.value]);
    const showHeurekaWidget = computed(() => !!heurekaWidgetOptions.value);
    const shouldWrapLayout = computed(() => {
      return showHeurekaWidget.value ? 'lg:flex-wrap' : '';
    });

    return {
      languageAndCountry,
      showTrustPilotWidget,
      trustpilotMiniWidgetId,
      heurekaWidgetOptions,
      showHeurekaWidget,
      shouldWrapLayout,
      TRUSTPILOT_MINI_WIDGET_WIDTH,
      TRUSTPILOT_MINI_WIDGET_HEIGHT,
    };
  },
});
